// Display-only values. Never pass these formatted amounts into transactions.
export const finiteAmount = (value) => {
  if (
    value === null ||
    value === undefined ||
    value === '' ||
    typeof value === 'boolean'
  )
    return null;
  const amount = Number(value);
  return Number.isFinite(amount) && amount >= 0 ? amount : null;
};
export const formatUsd = (value) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  }).format(value);
export const formatXlm = (value) =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 4,
  }).format(value);
export function campaignMetrics(el, liveprice, own = false) {
  const xlm = finiteAmount(el?.xlmRaised ?? el?.zeptaCoinsRaised);
  const storedUsd = finiteAmount(el?.usdCoinsRaised);
  const rate = finiteAmount(
    liveprice?.data?.data?.xlmPrice ??
      liveprice?.data?.data?.xlm_price ??
      liveprice?.data?.xlmPrice ??
      liveprice?.data?.xlm_price
  );
  const converted = xlm !== null && rate > 0 ? xlm * rate : null;
  // Retain the existing card conversion and precedence, with missing values explicit.
  const raised = own
    ? storedUsd
    : converted > 0
    ? converted
    : xlm > 0 && converted === null && !storedUsd
    ? null
    : storedUsd ?? converted;
  const target = finiteAmount(el?.targetAmountByUser);
  const targetXlm =
    finiteAmount(el?.targetAmountXlm) ??
    (rate > 0 && target > 0 ? target / rate : null);
  const progress =
    raised !== null && target > 0 ? (raised / target) * 100 : null;
  return {
    xlm,
    raised,
    target,
    targetXlm,
    progress,
    soldOut: target > 0 && raised !== null && raised >= target,
  };
}
export function campaignStatus(el, soldOut) {
  const state = String(el?.state || '').toLowerCase();
  const labels = {
    live: 'Live',
    finalised: 'Upcoming',
    successful: 'Funded',
    failed: 'Closed',
    stopped: 'Closed',
    paused: 'Paused',
    draft: 'Draft',
    verified: 'Verified',
    rejected: 'Closed',
    'in verification': 'In review',
  };
  const ended =
    el?.endDate &&
    Number.isFinite(Date.parse(el.endDate)) &&
    Date.parse(el.endDate) <= Date.now();
  return {
    label: soldOut
      ? 'Fully subscribed'
      : ended && state === 'live'
      ? 'Closed'
      : labels[state],
    canInvest: state === 'live' && !soldOut && !ended,
  };
}
export function artworkUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  let url = value.trim();
  if (/^ipfs:\/\//i.test(url)) {
    const path = url.replace(/^ipfs:\/\/(?:ipfs\/)?/i, '');
    return `${
      process.env.REACT_APP_IPFS_URL || 'https://ipfs.io/ipfs/'
    }${path}`;
  }
  if (/^(Qm[1-9A-HJ-NP-Za-km-z]{44}|bafy[a-z0-9]+)(\/.*)?$/.test(url))
    return `${process.env.REACT_APP_IPFS_URL || 'https://ipfs.io/ipfs/'}${url}`;
  if (url.startsWith('//')) url = `https:${url}`;
  try {
    const parsed = new URL(
      url,
      process.env.REACT_APP_BASE_URL || window.location.origin
    );
    if (!['http:', 'https:'].includes(parsed.protocol)) return '';
    // Use the same music's full-size thumbnail, rather than stretching 120px previews.
    if (['img.youtube.com', 'i.ytimg.com'].includes(parsed.hostname)) {
      parsed.protocol = 'https:';
      parsed.pathname = parsed.pathname.replace(
        /\/default\.jpg$/,
        '/hqdefault.jpg'
      );
    }
    return parsed.href;
  } catch {
    return '';
  }
}
